import { CommonUtility } from '../utility/common';

const BADGE_MAX = 99;

export function formatBadge(count) {
  return count > BADGE_MAX ? `${BADGE_MAX}+` : String(count);
}

export function isMenuItemActive(item, pathname) {
  if (item.genericLink) {
    return pathname.includes(item.genericLink);
  }
  if (item.link) {
    return CommonUtility.compareUrls(item.link, pathname);
  }
  return false;
}

/** @returns {{ selectedKey: string | undefined, openGroupKey: string | undefined }} */
export function getMenuSelection(menus, pathname) {
  for (const group of menus) {
    for (const child of group.menus || []) {
      if (isMenuItemActive(child, pathname)) {
        return { selectedKey: child.key, openGroupKey: group.key };
      }
    }
    if (group.link && isMenuItemActive(group, pathname)) {
      return { selectedKey: group.key, openGroupKey: group.key };
    }
  }
  return { selectedKey: undefined, openGroupKey: undefined };
}

/** @param {string} pathname */
export function getPageMeta(menus, pathname) {
  for (const group of menus) {
    for (const child of group.menus || []) {
      if (isMenuItemActive(child, pathname)) {
        return { label: child.text, phosphorIcon: child.phosphorIcon };
      }
    }
    if (group.link && isMenuItemActive(group, pathname)) {
      return { label: group.text, phosphorIcon: group.phosphorIcon };
    }
  }
  return null;
}

export function sumChildCounts(children) {
  if (!children) return 0;
  return children.reduce((sum, child) => sum + (child.count ?? 0), 0);
}
